import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./api/apiSlice";
import productSlice from "../features/products/productSlice";
import generalSlice from "../features/general/generalSlice";
import authSlice from "../features/auth/authSlice";
import userSlice from "../features/users/userSlice";
import categorySlice from "../features/categories/categorySlice";
import subCategorySlice from "../features/subCategories/subCategorySlice";
import brandSlice from "../features/brands/brandSlice";
import { enableMapSet } from 'immer';

enableMapSet();

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    products: productSlice,
    general: generalSlice,
    user: userSlice,
    auth: authSlice,
    categories: categorySlice,
    subCategories: subCategorySlice,
    brands: brandSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
});
